export default "__VITE_ASSET__DGHhMSXX__"